<div class="echarts" echarts [options]="chartOption" (chartClick)="onChartClick($event);" *ngIf="histogramData?.length">
</div>
<div *ngIf="!histogramData?.length" class="place-center h-100 no-data-style">No Data</div>